export { default, links, meta } from "/Users/Quentin/Documents/Projects/Web/Remix/comment-decorations/app/root.tsx";